import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import InscriptionFormBacNoAffiliate from "../components/InscriptionFormBacNoAffiliate";
import {IMAGES, MESSAGES} from "../util/Messages";


export default class InscriptionBacNoAffiliateApp extends React.Component {
  render() {
    return (
      <>
        <WelComeLayer logo={IMAGES.colsubidio} footer={IMAGES.footerColsubsidio} message={MESSAGES.WELCOME_MESSAGE_COLSUBSIDIO}/>
        <InscriptionFormBacNoAffiliate />
      </>
    );
  }
}
